var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flight-select-container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.flightData,
              expression: "flightData"
            }
          ],
          staticClass: "flight-select"
        },
        [
          _c("div", { staticClass: "flight-select-header" }, [
            _vm._v("View bag prices for:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flight-select-dropdowns" },
            [
              _vm.departFlights && _vm.departFlights.length
                ? _c(
                    "f9field2",
                    {
                      staticClass: "flight-select-route",
                      attrs: {
                        label:
                          "Departure Time (" +
                          _vm.origin +
                          " > " +
                          _vm.destination +
                          ")"
                      }
                    },
                    [
                      _c("f9select2", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "depart_time",
                          items: _vm.departFlights
                        },
                        model: {
                          value: _vm.departureFlight,
                          callback: function($$v) {
                            _vm.departureFlight = $$v
                          },
                          expression: "departureFlight"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.roundTrip && _vm.returnFlights && _vm.returnFlights.length
                ? _c(
                    "f9field2",
                    {
                      staticClass: "flight-select-route",
                      attrs: {
                        label:
                          "Return Time (" +
                          _vm.destination +
                          " > " +
                          _vm.origin +
                          ")"
                      }
                    },
                    [
                      _c("f9select2", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "return_time",
                          items: _vm.returnFlights
                        },
                        model: {
                          value: _vm.returnFlight,
                          callback: function($$v) {
                            _vm.returnFlight = $$v
                          },
                          expression: "returnFlight"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "f9button2",
                {
                  staticClass: "flight-select-search",
                  attrs: { loading: _vm.searching },
                  on: { click: _vm.selectFlights }
                },
                [_vm._v("Search")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "unavailable",
          staticClass: "flight-unavailable-container",
          class: { noheight: !_vm.flightUnavailable }
        },
        [
          _c("div", { staticClass: "flight-unavailable" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errorMessage,
                    expression: "errorMessage"
                  }
                ],
                staticClass: "flight-unavailable-errorMessage"
              },
              [_vm._v(_vm._s(_vm.errorMessage))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.errorMessage,
                    expression: "!errorMessage"
                  }
                ],
                staticClass: "flight-unavailable-header"
              },
              [
                _vm._v("Please select another"),
                _c("span", { staticClass: "hide-md hide-sm" }, [
                  _vm._v(" flight")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.errorMessage,
                    expression: "!errorMessage"
                  }
                ],
                staticClass: "flight-unavailable-sub"
              },
              [
                _vm._v(
                  "One or more of your selected flights is not available. "
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("bag-price-grid", {
        ref: "grid",
        staticClass: "flight-select-grid",
        class: {
          noheight:
            !_vm.priceArray || _vm.searchChanged || _vm.flightUnavailable
        },
        attrs: {
          "price-data": _vm.priceArray,
          "is-existing": _vm.isExisting,
          disabledColumns: _vm.disabledColumns
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "footer-info",
          class: {
            noheight:
              !_vm.priceArray || _vm.searchChanged || _vm.flightUnavailable
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "t-and-c-text" }, [
            _vm._v(
              "\n            *All prices are per person, per direction. Prices are valid for this browser session ONLY. To lock in these prices, you must complete your booking before your session expires. If you did not complete all sections of this form, or your actual booking varies from the information you provided, then your prices may be different from those listed above. In some instances, a government tax may be applied to your baggage price, which will be reflected in the total price quoted to you before you book. Active duty military passengers, subject to verification, may bring one carry-on bag and/or may check up to two bags, which may be oversized and/or overweight, for free. This benefit does not extend to family members or other traveling companions.\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "t-and-c-service-charge" }, [
            _vm._v(
              "A service charge of up to $25 per person per direction applies to all agent assisted transactions."
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "peronal-item-info" }, [
      _c("b", [_vm._v("1 Personal item is included")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a72acab", { render: render, staticRenderFns: staticRenderFns })
  }
}